<!-- 全部破产案件 -->
<template>
    <div id="join">
        <loading-overlay v-if="loading"></loading-overlay>
        <!-- 操作 -->
        <div class="search">
            <el-form ref="form" :model="form" label-width="90px">
                <el-row>
                    <el-col :span="6">
                        <el-form-item class="cder" label="案件名称">
                            <el-input clearable v-model="form.name" prefix-icon="el-icon-search"
                                placeholder="请输入案件名称"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="6">
                        <el-form-item class="cder" label="律师">
                            <el-input v-model="form.lvshi" placeholder="请输入律师" class="select" clearable></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="6">
                        <el-form-item class="cder" label="已中标">
                            <el-select filterable v-model="form.isBidder" placeholder="请选择" class="select" clearable>
                                <el-option v-for="item in isBidder" :key="item.value" :label="item.label"
                                    :value="item.value">
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :span="6">
                        <el-form-item class="cder" label="案件类型">
                            <el-select filterable v-model="form.type" placeholder="请选择案件类型" class="select" clearable>
                                <el-option v-for="item in Casetype" :key="item.value" :label="item.label"
                                    :value="item.value">
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row>

                    <el-col :span="6">
                        <el-form-item class="cder" label="案件状态">
                            <el-select clearable v-model="form.state" placeholder="请选择案件状态" class="select">
                                <el-option v-for="item in Status" :key="item.value" :label="item.label"
                                    :value="item.value">
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :span="6">
                        <el-form-item class="cder" label="案件编号">
                            <el-input v-model="form.number" placeholder="请输入案件编号" class="select" clearable></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="6">
                        <el-form-item class="cder" label="开始时间">
                            <el-date-picker class="select" v-model="form.starttime" value-format="yyyy-MM-dd"
                                type="date" placeholder="全部-起始" clearable>
                            </el-date-picker>
                        </el-form-item>
                    </el-col>
                    <el-col :span="6">
                        <el-form-item class="cder" label="结束时间">
                            <el-date-picker clearable class="select" v-model="form.endtime" value-format="yyyy-MM-dd"
                                type="date" placeholder="全部-终止">
                            </el-date-picker>
                        </el-form-item>
                    </el-col>

                </el-row>
                <el-row>

                    <el-col :span="12">
                        <el-form-item v-if="mystatus != 1" label="选择律所">
                            <!-- <el-select
                  v-model="form.lvsuo"
                  placeholder="请选择律所"
                  clearable
                >
                  <el-option
                    v-for="item in LvSuoList"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  ></el-option>
                </el-select> -->

                            <el-cascader class="cascader" v-model="form.lvsuo" placeholder="请选择律所" clearable
                                :options="LvSuoList" :props="{ checkStrictly: true }"></el-cascader>
                        </el-form-item>
                    </el-col>
                    <el-col :span="6">
                        <el-form-item label-width="0">
                            <el-button type="primary" @click="search1()">搜索</el-button>
                            <el-button type="danger" @click="clear()">重置</el-button>
                            <el-button type="primary" plain @click="Export()" v-if="$store.state.rolesname.includes('allCase_Export')
            ">导出</el-button>
                        </el-form-item>
                    </el-col>
                </el-row>
            </el-form>

            <!-- <el-button type="warning" size="mini" @click="search1()">搜索</el-button> -->
        </div>

        <el-table :data="tableData" :header-cell-style="{ textAlign: 'center' }" :cell-style="{ textAlign: 'center' }"
            style="width: 100%">
            <el-table-column prop="code" label="案件编号" width="130"></el-table-column>
            <el-table-column prop="title" label="案件名称" width="330"></el-table-column>
            <el-table-column prop="type" label="案件类型" width="130">
            </el-table-column>
            <el-table-column prop="cb_lvshi" label="承办律师" width="100">
                <template slot-scope="scope">
                    {{ arrToString(scope.row.cb_lvshi) }}
                </template>
            </el-table-column>
            <el-table-column prop="sh_lvshi" label="审核人" width="180">
                <template slot-scope="scope">
                    {{ arrobjectToString(scope.row.sh_lvshi) }}
                </template>
            </el-table-column>
            <el-table-column prop="posttime" label="提交时间" width="150" :formatter="formatTime"></el-table-column>

            <el-table-column label="案件状态" width="100" prop="status">
                <template slot-scope="scope">
                    <span v-if="scope.row.result == 0 && scope.row.status == 0" type="text"
                        class="casestatus">已通过</span>
                    <span v-if="scope.row.status == 1" type="text" class="casesresult">待审核</span>
                    <!-- <span v-if="scope.row.status == 2" type="text" class="casestatus">二次审核中</span> -->
                    <span v-if="scope.row.result == 1 && scope.row.status == 0" type="text"
                        class="casesrefuse">未通过</span>
                    <span v-if="scope.row.status == 2" type="text" class="casestatus">已结案</span>
                    <span v-if="scope.row.status == 3" type="text" class="casestatus">已归档</span>
                    <span v-if="scope.row.status == -1" type="text" class="casesrefuse">已删除</span>
                </template>
            </el-table-column>
            <!-- <el-table-column label="功能" width="500" fixed="right"> -->
            <el-table-column label="功能" fixed="right">
                <template slot-scope="scope">
                    <el-button v-show="Detail" type="success" plain size="small"
                        @click="selectCase(scope.row)">查看</el-button>
                    <el-popconfirm style="margin: 0 3% 0 3%" v-if="scope.row.status == 0 &&
            scope.row.result == 1 &&
            Case_del &&
            (scope.row.cbl.includes(scope.row.uid) ||
                scope.row.xll.includes(scope.row.uid))
            " title="是否确定删除该条数据？" @confirm="jqsClick(scope.row.id)">
                        <el-button type="warning" plain size="small" slot="reference">删除</el-button>
                    </el-popconfirm>
                    <el-popconfirm style="margin: 0 3% 0 3%" v-if="Case_del && scope.row.status != -1"
                        title="是否确定删除该条数据？" @confirm="jqsClick(scope.row.id)">
                        <el-button type="warning" plain size="small" slot="reference">删除</el-button>
                    </el-popconfirm>

                    <el-button title="是否确定重置该条数据？" v-if="scope.row.status == 0 &&
            scope.row.result == 0 &&
            (scope.row.cbl.includes(scope.row.uid) ||
                scope.row.xll.includes(scope.row.uid))
            " @click="chongZhi(scope.row)" type="danger" plain size="small" slot="reference">修改</el-button>

                    <el-button v-show="Case_saoma" type="primary" plain size="small"
                        @click="saoMa(scope.row.id)">扫码</el-button>
                    <el-button v-if="scope.row.bs &&
            scope.row.result == 0 &&
            scope.row.status == 0 &&
            $store.state.rolesname.includes('bankinput') &&
            scope.row.type == '破产案件投标'
            " type="warning" size="small" @click="enterBid(scope.row.id)">录入案件</el-button>
                </template>
            </el-table-column>
        </el-table>

        <div class="pagination">
            <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
                :current-page="currentPage" :page-sizes="[1, 5, 10, 15, 20]" :page-size="pageSize"
                layout="total, sizes, prev, pager, next, jumper" :total="total" v-if="bPageShow"></el-pagination>
        </div>
        <div style="margin-top:6px;display: flex;font-weight: 400; color: #606266; font-size: 13px;">
            <span style="margin-right: 15px;">投标破产案件: {{ this.bidcount }}</span>
            <span style="margin-right: 15px;">中标情况: {{ this.zbcount }}</span>
            <span style="margin-right: 15px;">重整案件: {{ this.czaj }}</span>
            <span style="margin-right: 15px;">预重整案件: {{ this.ycz }}</span>
            <span style="margin-right: 15px;">公益案件: {{ this.gyaj }}</span>
        </div>
        <el-dialog title="二维码" :visible.sync="Dialog" width="30%" style="text-align: center">
            <div class="erweima">
                <div id="ercode"></div>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import {
    allCaseApi,
    caseDeleteApi,
    getLvSuo,
    Exportdata,
    caseReject,
    SelectBankStatistics,
} from '../../api/case'
import QRCode from 'qrcodejs2'
export default {
    name: 'commitCase',

    // mixins: [],
    data() {
        return {
            mystatus: 6,
            next: false,
            loading: false,
            LvSuoList: [],
            bPageShow: true,

            tableData: [],
            currentPage: 1,
            pageSize: 10,
            total: 0,
            Dialog: false,
            dialogVisible: false,
            form: {
                lvsuo: '', //律所code
                name: '', //案件名称
                type: '', //案件类型
                state: null, //案件状态
                starttime: '', //提交时间-起始
                endtime: '', //提交时间-结束

                invoice: '', //是否开发票
                closecase: '', //是否结案
                isorNo: '', //是否归档
                lvshi: '', //律师
                number: '',// 案件编号
                isBidder: '',//是否中标
            },
            more: '',
            IsorNo: [
                { label: '是', value: true },
                { label: '否', value: false }
            ],
            Status: [
                { label: '已通过', value: 0 },
                { label: '审核中', value: 1 },
                { label: '结案', value: 2 },
                { label: '归档', value: 3 },
                { label: '未通过', value: 4 },
                { label: '删除', value: -1 }
            ],
            Casetype: [
                {
                    label: '破产案件投标',
                    value: '00000000-0012-0012-0013-000000000000'
                },
                {
                    label: '破产案件',
                    value: '00000000-0011-0011-0012-000000000000'
                }
            ],
            isBidder: [{ label: "是", value: true }, { label: "否", true: false }],
            Detail: false, // 查看
            Case_del: false, // 删除
            Case_saoma: false ,// 扫码
            zbcount:0,
            bidcount:0,
            czaj:0,
            ycz:0,
            gyaj:0,
        }
    },
    mounted() {
        // this.currentPage = this.$store.state.page
        this.bPageShow = false
        this.$nextTick(() => {
            this.bPageShow = true
        })

        this.GetLvSuo()
    },
    components: {
        // List
    },
    methods: {
        getvalue() {//传值给父组件，
            this.$emit('value', this.next)
        },
        chongZhi(row) {
            var caseType = row.typeid.substring(21, 23)
            if (caseType == 12) {
                this.$router.push({
                    path: 'bankruptdetail',
                    name: 'bankruptdetail',
                    query: {
                        guid: row.id,
                        type: '破产',
                        mystatus: this.mystatus,
                        bianji: true
                    }
                })
            } else if (caseType == 13) {
                this.$router.push({
                    path: 'bankruptdetail',
                    name: 'bankruptdetail',
                    query: {
                        guid: row.id,
                        type: '破产投标',
                        mystatus: this.mystatus,
                        bianji: true
                    }
                })
            }

        },
        enterBid(id) {
            let that = this
            that.$router.push({
                path: 'bankinput',
                query: { guid: id }
            })
        },
        Export() {
            //导出
            this.loading = true
            var starttime = null
            var endtime = null
            if (this.form.starttime) {
                starttime = this.JsonTime(this.form.starttime)
            }
            if (this.form.endtime) {
                endtime = this.JsonTime(this.form.endtime)
            }
            Exportdata({

                LS: this.form.lvsuo == '' ? null : this.form.lvsuo,
                Title: this.form.name,
                TypeId: this.form.type == '' ? null : this.form.type,

                State: this.form.state === '' ? null : this.form.state,
                StartTime: starttime,
                EndTime: endtime,
                LvShi: this.form.lvshi == '' ? null : this.form.lvshi,
                isBidder: this.form.isBidder == "" ? null : this.form.isBidder,
                MyStatus: 6,
            })
                .then((res) => {
                    if (res.data.status == 'success') {
                        this.$message.success('导出成功')
                        this.handleExportExcel(res.data.data)

                        this.loading = false
                    } else {
                        this.$message.error(res.data.message)
                        this.loading = false
                    }
                })
                .catch((res) => {
                    this.$message.error('导出失败')
                    this.loading = false
                })
        },
        handleExportExcel(base64String) {
            const link = document.createElement('a')
            link.href = 'data:application/octet-stream;base64,' + base64String
            link.download = 'export.xlsx' // 下载文件的名称
            link.click()
        },
        // 获取律所
        GetLvSuo() {
            getLvSuo({})
                .then((res) => {
                    // console.log('getLvSuo', res.data.data)
                    this.LvSuoList = res.data.data
                })
                .catch((err) => {
                    console.log(err)
                })
        },
        JsonTime(date) {
            // yyyy-MM-ddT HH:MM:SS
            var t = new Date(date).getTime()
            var d = new Date(t + 8 * 3600 * 1000).toISOString()
            return d
        },
        // 重置
        clear() {

            this.form.lvsuo = ''
            this.form.name = ''
            this.form.type = ''
            this.form.starttime = ''
            this.form.endtime = ''
            this.form.invoice = ''
            this.form.closecase = ''
            this.form.isorNo = ''
            this.form.lvshi = ''
            this.form.number = ''
            this.form.state = null
            this.form.isBidder = null,
                this.dialogVisible = false
            this.search1()
        },
        search1() {
            this.currentPage = 1
            this.searchSelect()
            this.GetSelectBank()
            console.log('LS', this.form.lvsuo)
        },
        // 搜索
        searchSelect() {
            // console.log('搜索')
            this.dialogVisible = false
            var starttime = null
            var endtime = null
            if (this.form.starttime) {
                starttime = this.JsonTime(this.form.starttime)
            }
            if (this.form.endtime) {
                endtime = this.JsonTime(this.form.endtime)
            }
            allCaseApi({
                LS:
                    this.form.lvsuo == ''
                        ? null
                        : this.form.lvsuo[this.form.lvsuo.length - 1],
                Title: this.form.name,
                TypeId: this.form.type == '' ? null : this.form.type,

                State: this.form.state === '' ? null : this.form.state,
                StartTime: starttime,
                EndTime: endtime,
                Invoice: this.form.invoice == '' ? null : this.form.invoice,
                CloseCase: this.form.closecase == '' ? null : this.form.closecase,
                isorNo: this.form.isorNo == '' ? null : this.form.isorNo,
                lvshi: this.form.lvshi,
                page: this.currentPage,
                rows: this.pageSize,
                MyStatus: 6, //(1:我的案例，2:全部案件，3:草稿案件，4:风控委案件，5:已归档案件,6:全部破产案件)
                SelectType: 0, //（0：案件管理，1：案件明细）
                No: this.form.number == '' ? null : this.form.number,
                isBidder: this.form.isBidder == "" ? null : this.form.isBidder,
            })
                .then((res) => {
                    if (res.data.status == '0') {
                        this.total = res.data.total
                        this.tableData = res.data.data.table
                        // this.zbcount =res.data.data.zbcount
                        // this.czaj =res.data.data.czaj
                        // this.ycz =res.data.data.ycz
                        // this.gyaj =res.data.data.gyaj
                        // this.bidcount =res.data.data.bidcount
                        
                    } else if (
                        res.data.status == '401' ||
                        res.data.status == '402' ||
                        res.data.status == '403'
                    ) {
                        this.$message.error(res.data.message)
                        window.sessionStorage.removeItem('token')
                        window.sessionStorage.removeItem('hasRoles')
                        this.$router.push('/login')
                    } else {
                        this.$message.error(res.data.message)
                    }
                })
                .catch(() => [this.$message.error('后台错误！')])
        },


        //更多选择
        moreSelect() {
            this.$refs.choose.blur()
            this.dialogVisible = true
        },
        // 删除
        jqsClick(id) {
            caseDeleteApi({
                Id: id
            }).then((res) => {
                if (res.data.data == '0') {
                    this.$message.success('删除成功!')
                    this.getAllPage()
                } else if (
                    res.data.status == '401' ||
                    res.data.status == '402' ||
                    res.data.status == '403'
                ) {
                    this.$message.error(res.data.message)
                    window.sessionStorage.removeItem('token')
                    window.sessionStorage.removeItem('hasRoles')
                    this.$router.push('/login')
                } else {
                    this.$message.error('删除失败!')
                }
            })
        },

        // Load获取数据
        async getAllPage() {
            var _this = this
            await allCaseApi({
                LS: this.form.lvsuo == '' ? null : this.form.lvsuo,
                Title: _this.form.name,
                TypeId: _this.form.type == '' ? null : _this.form.type,

                StartTime: _this.form.starttime == '' ? null : _this.form.starttime,
                EndTime: _this.form.endtime == '' ? null : _this.form.endtime,
                Invoice: _this.form.invoice == '' ? null : _this.form.invoice,
                CloseCase: _this.form.closecase == '' ? null : _this.form.closecase,
                isorNo: _this.form.isorNo == '' ? null : _this.form.isorNo,
                lvshi: this.form.lvshi,
                State: this.form.state === '' ? null : this.form.state,
                page: _this.currentPage,
                rows: _this.pageSize,
                MyStatus: 6, //(1:我的案例，2:全部案件，3:草稿案件，4:风控委案件，5:已归档案件,,全部破产案件)
                SelectType: 0, //（0：案件管理，1：案件明细）
                No: this.form.number == '' ? null : this.form.number,
                isBidder: this.form.isBidder == "" ? null : this.form.isBidder,

                
            })
                .then((res) => {
                    if (res.data.status == '0') {
                        this.total = res.data.total
                        this.tableData = res.data.data.table
                        // this.zbcount =res.data.data.zbcount
                        // this.czaj =res.data.data.czaj
                        // this.ycz =res.data.data.ycz
                        // this.gyaj =res.data.data.gyaj
                        // this.bidcount =res.data.data.bidcount
                    } else if (
                        res.data.status == '401' ||
                        res.data.status == '402' ||
                        res.data.status == '403'
                    ) {
                        _this.$message.error(res.data.message)
                        window.sessionStorage.removeItem('token')
                        window.sessionStorage.removeItem('hasRoles')
                        _this.$router.push('/login')
                    } else {
                        _this.$message.error(res.data.message)
                    }
                })
                .catch(() => {
                    _this.$message.error('后台错误！')
                })
        },

        async handleSizeChange(val) {
            this.pageSize = val
            await this.getAllPage()
        },
        async handleCurrentChange(val) {
            this.$store.commit('setPage', val)
            this.currentPage = val
            await this.getAllPage()
        },

        // 查看按钮
        selectCase(row) {
            var caseType = row.typeid.substring(21, 23)
            if (caseType == 12) {
                this.$router.push({
                    path: 'bankruptdetail',
                    name: 'bankruptdetail',
                    query: { guid: row.id, type: '破产', mystatus: this.mystatus }
                })
            } else if (caseType == 13) {
                this.$router.push({
                    path: 'bankruptdetail',
                    name: 'bankruptdetail',
                    query: { guid: row.id, type: '破产投标', mystatus: this.mystatus }
                })
            }
        },
        //生成二维码方法
        saoMa(id) {
            this.Dialog = true
            this.$nextTick(() => {
                let container = document.getElementById('ercode')
                if (container.innerHTML) {
                    container.innerHTML = ''
                }
                var text = 'case_' + id
                var qrcode = new QRCode(container, {
                    text: text, //这里就是二维码扫描后展示的内容了
                    width: 100,
                    height: 100,
                    colorDark: 'black',
                    colorLight: 'white',
                    correctLevel: QRCode.CorrectLevel.L //二维码的纠错等级，等级越高，二维码呈现越复杂，同时被遮挡的多，也能扫出来
                })
                qrcode.makeCode(text)
            })
        },
        // // 扫码
        // saoMa(id) {

        //   this.createQrcode(id)
        // },

        // 承办律师
        arrToString(arr) {
            return arr.join(' , ')
        },
        // 审核人/风控委
        arrobjectToString(arrobject) {
            var s = ''
            arrobject.forEach((value, index, array) => {
                s += value.nikename
                if (index < arrobject.length - 1) {
                    s = s + '，'
                }
            })
            return s
        },

        // 按钮过滤
        buttonFliter() {
            var type = this.mystatus
            if (this.$store.state.rolesname.includes('allbankDetail')) {
                    this.Detail = true
                }
                if (this.$store.state.rolesname.includes('all_casebankDelete')) {
                    this.Case_del = true
                }
                if (this.$store.state.rolesname.includes('all_casebankDelete')) {
                    this.Case_saoma = true
                }
        },

        // --时间格式转换--
        formatTime(row) {
            const date = new Date(row.posttime)
            // return row[column.property].Format('yyyy-MM-dd HH:mm')
            var year = date.getFullYear()
            /* 在日期格式中，月份是从0开始的，因此要加0
             * 使用三元表达式在小于10的前面加0，以达到格式统一  如 09:11:05
             * */
            var month =
                date.getMonth() + 1 < 10
                    ? '0' + (date.getMonth() + 1)
                    : date.getMonth() + 1
            var day = date.getDate() < 10 ? '0' + date.getDate() : date.getDate()
            var hours = date.getHours() < 10 ? '0' + date.getHours() : date.getHours()
            var minutes =
                date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes()
            var seconds =
                date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds()
            // 拼接
            if (hours == '00' && minutes == '00' && seconds == '00') {
                return year + '-' + month + '-' + day
            } else {
                return (
                    year + '-' + month + '-' + day
                    // +
                    // ' ' +
                    // hours +
                    // ':' +
                    // minutes +
                    // ':' +
                    // seconds
                )
            }
        },

        updateConditions() {
            const type = 'AllBankruptCase'
            if (this.$store.state.searchConditions[type]) {
                this.conditions = this.$store.state.searchConditions[type]
            }
        },
        // 搜索
        GetSelectBank() {
            // console.log('搜索')
            // this.dialogVisible = false
            var starttime = null
            var endtime = null
            if (this.form.starttime) {
                starttime = this.JsonTime(this.form.starttime)
            }
            if (this.form.endtime) {
                endtime = this.JsonTime(this.form.endtime)
            }
            SelectBankStatistics({
                LS:
                    this.form.lvsuo == ''
                        ? null
                        : this.form.lvsuo[this.form.lvsuo.length - 1],
                Title: this.form.name,
                TypeId: this.form.type == '' ? null : this.form.type,

                State: this.form.state === '' ? null : this.form.state,
                StartTime: starttime,
                EndTime: endtime,
                Invoice: this.form.invoice == '' ? null : this.form.invoice,
                CloseCase: this.form.closecase == '' ? null : this.form.closecase,
                isorNo: this.form.isorNo == '' ? null : this.form.isorNo,
                lvshi: this.form.lvshi,
                page: this.currentPage,
                rows: this.pageSize,
                MyStatus: 6, //(1:我的案例，2:全部案件，3:草稿案件，4:风控委案件，5:已归档案件,6:全部破产案件)
                SelectType: 0, //（0：案件管理，1：案件明细）
                No: this.form.number == '' ? null : this.form.number,
                isBidder: this.form.isBidder == "" ? null : this.form.isBidder,
            })
                .then((res) => {
                    if (res.data.status == '0') {
                        // this.total = res.data.total
                        // this.tableData = res.data.data.table
                        this.zbcount =res.data.data.zbcount
                        this.czaj =res.data.data.czaj
                        this.ycz =res.data.data.ycz
                        this.gyaj =res.data.data.gyaj
                        this.bidcount =res.data.data.bidcount
                        
                    } else if (
                        res.data.status == '401' ||
                        res.data.status == '402' ||
                        res.data.status == '403'
                    ) {
                        this.$message.error(res.data.message)
                        window.sessionStorage.removeItem('token')
                        window.sessionStorage.removeItem('hasRoles')
                        this.$router.push('/login')
                    } else {
                        this.$message.error(res.data.message)
                    }
                })
                .catch(() => [this.$message.error('后台错误！')])
        },
    },
    created() {
        this.$store.commit('setmenustatus', 0)
        this.$store.commit('setinputstatus', 0)
        this.buttonFliter()
        // this.GetSelectBank()
        this.getvalue()
    },
    beforeRouteLeave(to, from, next) {
        // console.log("离开",to.name)
        const type = 'AllBankruptCase'
        if (to.name == 'bankruptdetail' || to.name == 'bankruptfile') {
            var con = {
                form: this.form,
                PageIndex: this.currentPage,
                PageSize: this.pageSize
            }
            this.$store.dispatch('saveSearchCondition', { type, condition: con }) //保存
        } else {
            this.$store.dispatch('clearSearchConditions', type) //保存
        }

        next()
    },
    beforeRouteEnter(to, from, next) {
        // 辅助函数，用于在组件实例化之前执行一些代码
        function fetchData() {
            const type = 'AllBankruptCase'
            
            // 从 Vuex store 中读取搜索条件
            if (this.$store.state.searchConditions[type]) {
                return this.$store.state.searchConditions[type]
            }
            return null
        }
        // 通过 next 回调访问组件实例
        next((vm) => {
            const fetchedData = fetchData.call(vm)
           
            if (
                fetchedData &&
                (from.name == 'bankruptdetail' || from.name == 'bankruptfile')
            ) {
                vm.form = fetchedData.form
                vm.currentPage = fetchedData.PageIndex
                vm.pageSize = fetchedData.PageSize
                // console.log(fetchedData.PageIndex)
                vm.bPageShow = false
                vm.$nextTick(() => {
                    vm.bPageShow = true
                })
                vm.searchSelect()
                vm.GetSelectBank()
            } else {
                vm.searchSelect()
                vm.GetSelectBank()
            }
        })
    },
}
</script>

<style lang="less" scoped>
#join {

    // position: relative;
    .search {
        box-sizing: border-box;
        // display: flex;
        padding: 0 0 0 1%;
        width: 100%;

        // .el-input {
        //   width: 20%;
        // }
        .cder {
            ::v-deep .el-input__inner {
                // width: 80% !important;
                width: 14vw;
                height: 45px;
                background-color: #fafafa;
                border: 0 !important;
            }
        }

        .el-select {
            // margin: 0 10px;
            width: 150px;
        }
    }

    .pagination {
        // margin-top: 18px;
        margin: 20px 0px 20px 0px;
        width: 100%;
        overflow: hidden;
        text-align: right;
    }

    /* ::v-deep穿透 改变element ui组件样式 */
    ::v-deep .pagination .el-pagination__total {
        float: left;
    }

    ::v-deep .pagination .el-pagination__sizes {
        float: left;
    }

    ::v-deep .ajzt {
        color: #2bc887;
    }

    .btn {
        width: 100%;
        text-align: center;
    }
}

.casestatus {
    color: #2bc887;
}

.casesresult {
    color: #fe964a;
}

.casesrefuse {
    color: #df0d0d;
}

.erweima {
    width: 100px;
    margin: auto;
}

.select {
    width: 100%;
}

.cascader {
    ::v-deep .el-input__inner {
        width: 38vw;
        height: 45px;
        background-color: #fafafa;
        border: 0 !important;
    }
}

::v-deep .el-form-item {
    margin-bottom: 16px !important;
}
</style>